"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetupUserProvider = void 0;
var _auth = require("@ori/auth");
var _logger = require("@ori/logger");
var _userSessionProvider = require("@ori/user-session-provider");
var _react = require("react");
const useSetupUserProvider = () => {
  const logger = (0, _logger.useLogger)('useSetupUserProvider');
  const {
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  (0, _react.useEffect)(() => {
    if (!isAnonymousUser && isUserVerified) {
      try {
        (0, _userSessionProvider.setupUserProvider)();
      } catch (error) {
        logger.error(new Error('Failed to setup user provider', {
          cause: error
        }));
      }
    }
  }, [isAnonymousUser, isUserVerified, logger]);
};
exports.useSetupUserProvider = useSetupUserProvider;
